// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-close[data-v-1a632208] {\n  z-index: 1;\n}\n.c-close[data-v-1a632208]:hover {\n  transform: scale(1.1);\n  color: var(--v-primary-base);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
